import { Component, ViewChild, OnInit, AfterViewInit, inject, NgZone, ElementRef } from '@angular/core';
import { MatSidenav, MatSidenavContainer } from '@angular/material/sidenav';
import { LoginService } from '../login/login.service';
import { Router, NavigationEnd } from '@angular/router';
import { Permissions } from '../auth-guard.guard';
import { environment } from '@env/environment';
import { filter } from 'rxjs/operators';


export interface SidebarLink {
    href: string;
    name: string;
    icon: string;
}

@Component({
    selector: 'app-nav',
    templateUrl: './nav.component.html',
    styleUrls: ['./nav.component.css']
})

export class NavComponent implements OnInit, AfterViewInit {
    @ViewChild('sidenav') public sidenav!: MatSidenav;
    @ViewChild(MatSidenavContainer) sidenavContainer!: MatSidenavContainer;
    @ViewChild('scrollContainer') scrollContainer!: ElementRef<HTMLElement>;

    private ngZone = inject(NgZone);

    sidebarLinks: SidebarLink[] = [
        { href: '/home', name: 'Home', icon: 'home' },
        { href: '/dashboard', name: 'Dashboard', icon: 'dashboard' },
        { href: '/joborder', name: 'Job Entry', icon: 'format_list_bulleted' },
        { href: '/jobschedule', name: 'Production', icon: 'precision_manufacturing' },
        { href: '/master', name: 'Masters', icon: 'storage' },
        { href: '/challan', name: 'Challan', icon: 'local_shipping' },
        { href: '/accounting', name: 'Accounting', icon: 'account_balance' },
        { href: '/production-transfer', name: 'Production Transfer', icon: 'swap_horiz' },
        { href: '/company', name: 'Company Setup', icon: 'business' },
        { href: '/reports', name: 'Reports', icon: 'insert_chart' },
        { href: '/userrole', name: 'Access Control', icon: 'security' },
    ];

    constructor(
        public auth: LoginService,
        public router: Router,
        public permissions: Permissions
    ) {}

    isExpanded = true;
    showSubmenu = false;
    isShowing = false;
    showSubSubMenu = false;
    currentUser: any;
    uat = environment.uat;

    // Toolbar link groups for sub-navigation
    productToolbar: string[] = ['/product', '/process', '/category', '/jobchecklist', '/shipment', '/hsn', '/pricelist'];
    companyToolbar: string[] = ['/company', '/employee', '/department'];
    accessToolbar: string[] = ['/userrole', '/auth'];
    doctorToolbar: string[] = ['/doctor', '/state', '/area'];
    jobOrderToolbar: string[] = ['/joborder', '/remark'];
    productionToolbar: string[] = ['/jobschedule', '/prodjobin', '/prodjobout', '/productionout', '/employeelogin/out', '/employeelogin/in'];
    invoicingToolbar: string[] = ['/invoice', '/proforma', '/account', '/account_receipt', '/note', '/journal_voucher', '/knock_off'];
    challanToolbar: string[] = ['/challan'];

    ngOnInit() {
        this.currentUser = this.auth.currentUserValue;

        // Scroll to top on route change
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        ).subscribe(() => {
            if (this.scrollContainer?.nativeElement) {
                this.scrollContainer.nativeElement.scrollTop = 0;
            }
        });
    }

    ngAfterViewInit() {
        this.ngZone.runOutsideAngular(() => {
            [0, 50, 100, 200, 300, 500].forEach(delay => {
                setTimeout(() => {
                    this.ngZone.run(() => {
                        if (this.sidenavContainer) {
                            this.sidenavContainer.updateContentMargins();
                        }
                    });
                }, delay);
            });
        });
    }

    get visibleSidebarLinks(): SidebarLink[] {
        return this.sidebarLinks.filter((l) => {
            const url = l.href;
            return this.permissions.canActivate(this.currentUser?.user, url);
        });
    }

    mouseenter() {
        if (!this.isExpanded) {
            this.isShowing = true;
        }
    }

    mouseleave() {
        if (!this.isExpanded) {
            this.isShowing = false;
        }
    }

    logout() {
        this.auth.logout();
    }

    toggleSidenav() {
        this.isExpanded = !this.isExpanded;
        this.triggerResize();
    }

    private triggerResize() {
        const updates = [0, 50, 100, 150, 200, 250, 300];
        updates.forEach(delay => {
            setTimeout(() => {
                this.sidenavContainer?.updateContentMargins();
            }, delay);
        });
    }

    changePassword() {
        this.router.navigate(['/change-password']);
    }
}
